import type { DropzoneInputProps, DropzoneRootProps } from "react-dropzone";
import type { Asset } from "schemas/generated/asset";

import React from "react";

import { ReploAssetsGrid } from "@v2/features/assets/components/asset-grid/ReploAssetsGrid";

interface AssetContextItemsListProps {
  onAssetSelect: (asset: Asset) => void;
  searchQuery: string;
  getRootProps: (props?: DropzoneRootProps | undefined) => DropzoneRootProps;
  getInputProps: (props?: DropzoneInputProps | undefined) => DropzoneInputProps;
  droppedFilesMap: Map<string, File>;
  isDragActive: boolean;
  assetTypes?: ("image" | "video")[];
}

export const AssetContextItemsList: React.FC<AssetContextItemsListProps> = ({
  searchQuery,
  onAssetSelect,
  getRootProps,
  getInputProps,
  droppedFilesMap,
  isDragActive,
  assetTypes = ["image", "video"],
}) => {
  return (
    <div
      className="flex flex-col gap-1 p-2 h-full min-h-0 overflow-hidden"
      data-list-container="assets"
    >
      <ReploAssetsGrid
        assetTypes={assetTypes}
        searchTerm={searchQuery}
        onAssetSelected={onAssetSelect}
        shouldAllowActions
        getDropzoneRootProps={getRootProps}
        getDropzoneInputProps={getInputProps}
        droppedFilesMap={droppedFilesMap}
        isDragActive={isDragActive}
      />
    </div>
  );
};
